import { AwardingClient } from "@/utils/EvoClient";
import { ChangeAwardUnitDto } from "../dto";
import { AxiosResponse } from "axios";

const ENDPOINT = "c/change-award-unit";

export default async function changeAwardUnit(
  dto: ChangeAwardUnitDto
): Promise<string> {
  return ((await AwardingClient.post(ENDPOINT, dto)) as AxiosResponse).data.id;
}
